export default "__VITE_ASSET__DbGoZN_k__"